import React, {useEffect, useState} from 'react';
import {Form, Icon, Modal} from 'antd';
import moment from 'moment';
import {validationMessage} from './validationMessages';
import api from '../../api/api';
import DynamicIcon from "../DynamicIcon";
import FormInput from "../FormInput/FormInput";
import {useThemeSelector} from "../../redux/reducers/themeReducer";

const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
};
const tailLayout = {
    wrapperCol: {offset: 8, span: 16},
};

const GenericCreateUpdateModal = props => {
    const [form] = Form.useForm();
    const {darkMode} = useThemeSelector();

    const [modalState, setModalState] = useState({
        validationRules: [],
        selectOptions: [],
        imageUrl: null,
        loading: false
    });

    useEffect(() => {

        let fieldValidationRule = [];
        props.fields.map(({validationRules = [], key, required, title, type, optionsLinkFetch, optionsData}) => {

            if (required && !validationRules.some(i => i.required)) {
                validationRules.push({
                    required,
                    message: title + ' is required!'
                });
            }

            validationRules = validationRules.map(rule => {
                if (!rule.message) {
                    if (rule.min) {
                        rule.message = validationMessage("min", rule.min);
                    } else if (rule.max) {
                        rule.message = validationMessage("max", rule.max);
                    } else if (rule.len) {
                        rule.message = validationMessage("len", rule.len);
                    }
                }
                return rule;
            });

            fieldValidationRule.push({key, rules: validationRules});

            if (type === 'select') {
                if (optionsLinkFetch) {
                    api.get(optionsLinkFetch).then(resp => {
                        let newSelectOptions = [...modalState.selectOptions];
                        newSelectOptions.push({key: key, options: resp.data});
                        this.setState({selectOptions: newSelectOptions});
                    }).catch(err => {
                        console.log("error");
                    })
                } else if (optionsData) {
                    let newSelectOptions = [...modalState.selectOptions];
                    newSelectOptions.push({key, options: optionsData});
                    this.setState({selectOptions: newSelectOptions});
                }
            }
        });

        const modalStateTemp = {...modalState};
        modalStateTemp.validationRules = fieldValidationRule;
        setModalState(modalStateTemp);
    }, []);

    const handleChange = (info, columnKey) => {
        if (info.file.status === 'uploading') {
            this.setState({loading: true});
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            this.getBase64(info.file.originFileObj, imageUrl => {
                    this.setState({
                        imageUrl,
                        loading: false,
                    })
                }, columnKey
            );
            return false;
        }
    };

    const getBase64 = (img, callback, columnKey) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            props.form.setFieldsValue({columnKey: reader.result});
            callback(reader.result)
        });
        reader.readAsDataURL(img);
    };

    const item = props.initialValue || {};

    useEffect(() => {
        form.setFieldsValue(item);
    }, [item.id]);

    return (<Modal
            title={props.title ? props.title : 'Generic modal'}
            destroyOnClose={true}
            visible={props.visible}
            className={darkMode && 'dark-mode'}
            okButtonProps = {{
                loading: props.submitPending
            }}
            cancelButtonProps = {{
                disabled: props.submitPending
            }}
            onOk={async () => {
                try {
                    const keys = props.fields.map(item => item.key);

                    const values = await form.validateFields(keys);
                    let filePresent = false;

                    props.fields.forEach(field => {
                        if (field.type === 'datetime') {
                            values[field.key] = moment(values[field.key], 'HH:mm:ss');
                        }
                        if (field.type === 'upload') {
                            filePresent = true;
                            values[field.key] = values[field.key].file.originFileObj
                        }
                    });

                    if (props.initialValue && props.initialValue.id) {
                        values.id = props.initialValue.id;
                    }

                    props.onOk(values, filePresent);

                } catch (e) {

                }
            }}
            onCancel={props.onCancel}
        >
            <Form form={form} initialValues={item} {...layout}>
                {
                    props.fields.map(({key, type, title, icon = "RightOutlined", options, url, displayColumn, tooltip, autoSize}) => {
                        const validationRules = props.fields.find(i => i.key === key)?.validationRules;

                        return <FormInput label={title} name={key} key={key} options={options} url={url} displayColumn={displayColumn} tooltip={tooltip}
                                          icon={<DynamicIcon type={icon} style={{color: 'rgba(0,0,0,.25)'}}/>}
                                          rules={validationRules}
                                          placeholder={title}
                                          readOnly={props.submitPending}
                                          type={type}/>;
                    })}
            </Form>
        </Modal>
    )
};

export default GenericCreateUpdateModal;